import _implicitStylesheets from "./loginCard.css";

import _implicitScopedStylesheets from "./loginCard.scoped.css?scoped=true";

import _lightningRadioGroup from "lightning/radioGroup";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {h: api_element, d: api_dynamic_text, t: api_text, b: api_bind, c: api_custom_element, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("article", {
    classMap: {
      "slds-card": true,
      "login-card_align": true
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "slds-card__header": true,
      "slds-grid": true
    },
    key: 1
  }, [api_element("header", {
    classMap: {
      "slds-media": true,
      "slds-media_center": true,
      "slds-has-flexi-truncate": true
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "slds-media__figure": true,
      "card-number_size": true
    },
    attrs: {
      "data-my-id": "card-number"
    },
    key: 3
  }, [api_element("img", {
    attrs: {
      "src": $cmp.cardNumberPath
    },
    key: 4
  }, [])]), api_element("div", {
    classMap: {
      "slds-media__body": true
    },
    attrs: {
      "data-my-id": "card-title"
    },
    key: 5
  }, [api_element("h2", {
    classMap: {
      "card-title_style": true
    },
    key: 6
  }, [api_element("span", {
    key: 7
  }, [api_text(api_dynamic_text($cmp.cardTitle))])])])])]), api_element("div", {
    classMap: {
      "slds-grid": true
    },
    key: 8
  }, [api_element("div", {
    classMap: {
      "connect-to-org-button_padding": true
    },
    key: 9
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true
    },
    attrs: {
      "disabled": $cmp.disableCard ? "" : null,
      "data-my-id": "connect-to-org"
    },
    key: 10,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleConnectToOrg))
    }
  }, [api_text(api_dynamic_text($cmp.connectToOrgtitle))])]), api_element("div", {
    classMap: {
      "env-types_style": true
    },
    key: 11
  }, [api_custom_element("lightning-radio-group", _lightningRadioGroup, {
    props: {
      "options": $cmp.envTypes,
      "value": $cmp.value,
      "type": "radio",
      "disabled": $cmp.disableCard
    },
    key: 12,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleEnvChange))
    }
  }, [])])]), $cmp.showFileUpload ? api_element("div", {
    key: 13
  }, [api_element("h2", {
    classMap: {
      "or_text_style": true
    },
    attrs: {
      "data-my-id": "or-text"
    },
    key: 14
  }, [api_element("span", {
    key: 15
  }, [api_text(" OR ")])])]) : null, $cmp.showFileUpload ? api_element("div", {
    styleDecls: [["margin-left", "2rem", false], ["padding-bottom", "2rem", false]],
    key: 16
  }, [api_element("div", {
    classMap: {
      "slds-form-element": true,
      "slds-has-error": true,
      "import-file_align": true
    },
    attrs: {
      "data-my-id": "upload-file"
    },
    key: 17
  }, [api_element("span", {
    classMap: {
      "slds-form-element__label": true
    },
    attrs: {
      "id": api_scoped_id("file-selector-primary-label")
    },
    key: 18
  }, []), api_element("div", {
    classMap: {
      "slds-form-element__control": true
    },
    key: 19
  }, [api_element("div", {
    classMap: {
      "slds-file-selector": true,
      "slds-file-selector_files": true
    },
    key: 20
  }, [api_element("div", {
    classMap: {
      "slds-file-selector__dropzone": true
    },
    key: 21
  }, [api_element("input", {
    classMap: {
      "slds-file-selector__input": true,
      "slds-assistive-text": true
    },
    attrs: {
      "type": "file",
      "accept": ".zip",
      "id": api_scoped_id("file-upload-input-01"),
      "data-my-id": "uploadFile",
      "aria-labelledby": api_scoped_id("file-selector-primary-label file-selector-secondary-label")
    },
    key: 22,
    on: {
      "change": _m2 || ($ctx._m2 = api_bind($cmp.handleUploadFile))
    }
  }, []), api_element("label", {
    classMap: {
      "slds-file-selector__body": true
    },
    attrs: {
      "for": api_scoped_id("file-upload-input-01"),
      "id": api_scoped_id("file-selector-secondary-label")
    },
    key: 23
  }, [api_element("span", {
    classMap: {
      "slds-file-selector__button": true,
      "slds-button": true,
      "slds-button_neutral": true
    },
    key: 24
  }, [api_text("Upload File")])])])])])])]) : null])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-loginCard_loginCard"
